// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1iB4w","log":"ModalInventoryLogs_log__2iRNo","date":"ModalInventoryLogs_date__1C6fD","userName":"ModalInventoryLogs_userName__3w8b9"};